<template>
  <el-menu
    :default-active="defaultRouter"
    router
    unique-opened
    class="el-menu-demo"
    mode="vertical"
    background-color="#4f81bd"
    text-color="#fff"
    active-text-color="#ffd04b"
    :default-openeds="isShow"
    @open="handleOpen"
  >
    <!-- :default-openeds="['合同管理','订单管理','设备号管理','售后管理','财务','型号选择']" -->
    <div v-for="(nav,index) in Menus" :key="index">
      <div v-if="index>1" >
        <!--        <div v-if="nav.meta.permission?(nav.meta.permission).indexOf(permission)>=0:true">-->
        <div>
          <el-submenu
            v-if="nav.hasOwnProperty('children')&&nav.children.length>0"
            :key="index"
            :index="nav.path"
          >
            <template slot="title">
              <div >
                <i :class="[nav.icon,'icons']"></i>
                <span slot="title">{{ nav.meta.title }}</span>
              </div>
            </template>
            <div v-for="(item,index) in nav.children" :key="index">
              <div >
                <el-menu-item :index="item.path">
                  <!-- <i :class="item.icon"></i> -->
                  <span >{{ item.meta.title }}</span>
                </el-menu-item>
              </div>

              <!-- </div> -->
            </div>
          </el-submenu>
          <el-menu-item v-else :index="nav.path">
            <!-- 没有子菜单的元素 -->
            <div >
              <i :class="[nav.icon,'icons']"></i>
              <span>{{ nav.meta.title }}</span>
            </div>
          </el-menu-item>
        </div>
      </div>
    </div>
  </el-menu>
</template>
<script>
import {mapGetters} from "vuex";
import PC from '@/router/PC.js'
import router from "../router";

export default {
  name: "navigator",
  data() {
    return {
      defaultRouter: "",
      Menus: [],
      isShow: []
    };
  },
  computed: {
    ...mapGetters([ "permission"])
  },
  mounted() {
    const dynamicState = this.$store.state.permission.menus
    dynamicState.forEach(item => {
      item.children = item.childrenMenus
    })
    this.Menus = [ ...PC,...dynamicState]

    // console.log("获取菜单信息渲染", this.Menus)
    // console.log("获取所有路由",router.getRoutes())
  },
  watch: {
    $route(curVal, oldVal) {
      if (this.$route.path == "/") {
        this.defaultRouter = "/home";
      } else {
        this.defaultRouter = this.$route.path;
        let str = curVal.path.split("/")[1];
        // console.log(str);
        // this.isShow = ["/" + str];
        // console.log(this.isShow);
      }
    }
  },
  methods: {

    handleOpen(key, keyPath) {
      this.isShow = [key];
      switch (key) {
        case "/contract":
          this.defaultRouter = "/contract/list";
          this.$router.push("/contract/list");
          break;
        case "/order":
          this.defaultRouter = "/order/list";
          this.$router.push("/order/list");
          break;
        case "/equipment":
          this.defaultRouter = "/equipment/list";
          this.$router.push("/equipment/list");
          break;
        case "/finance":
          this.defaultRouter = "/finance/list";
          this.$router.push("/finance/list");
          break;
        // case "/aftermarket":
        //   this.defaultRouter = "/aftermarket/list";
        //   this.$router.push("/aftermarket/list");
        //   break;
        case "/machine":
          this.defaultRouter = "/machine/list";
          this.$router.push("/machine/list");
          break;
        // case "/system":
        //   this.defaultRouter = "/system/user/list";
        //   this.$router.push("/system/user/list");
        //   break;
/*        case "/CDKEY":
          this.defaultRouter = "/CDKEY/add";
          this.$router.push("/CDKEY/add");
          break;*/
        default:
          console.log(key, keyPath);
          // this.defaultRouter = "/";
          // this.$router.push("/");
          break;

      }
    }
  }
};
</script>
<style scoped>
.out-box {
  height: 100%;
  background: #4f81bd;
  overflow: hidden;
}

.el-menu-demo {
  border: 0;
  height: 100%;
}

.icons {
  color: #fff;
}
</style>>



// WEBPACK FOOTER //
// src/components/navigator.vue